var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-arrow-right';
                    var viewUrl = 'sprite.svg#view-icon-arrow-right';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-arrow-right#icon-arrow-right';
                            viewUrl = 'sprite.svg?icon-arrow-right#view-icon-arrow-right';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 6 10',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };